import ReactGA from 'react-ga4'
import { getTitle } from '../../routes'

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID
const GA_ENABLED = process.env.REACT_APP_GA_ENABLED !== 'false'

let isInitialized = false

export const GTM_EVENT_PAGE_VIEW = 'PAGE_VIEW'
export const GTM_EVENT_PURCHASE = 'purchase'

export const initializeGtm = () => {
  if (!GA_ENABLED || !GA_MEASUREMENT_ID) {
    console.warn('Google Analytics desativado via variável de ambiente')
    return
  }
  ReactGA.initialize(GA_MEASUREMENT_ID)
  isInitialized = true
}

export const logPageView = () => {
  if (!isInitialized) return

  const title = getTitle()

  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname,
    title,
  })
}

export const logPurchase = () => {
  if (!isInitialized) return

  const title = getTitle()
  const selecao = sessionStorage.getItem('selecaoServicos')

  if (selecao) {
    try {
      const decoded = JSON.parse(selecao)
      ReactGA.event('purchase', {
        currency: 'BRL',
        value: decoded?.carrinho?.servicoPrincipal?.valor ?? 0,
        items: [{
          item_name: decoded?.carrinho?.servicoPrincipal?.nome ?? 'Servico Principal',
          price: decoded?.carrinho?.servicoPrincipal?.valor ?? 0,
          quantity: 1,
        }],
        page_title: title,
        page_location: window.location.href,
      })
    } catch (e) {
      console.error('Erro ao enviar evento de purchase ao GA4', e)
    }
  }
}

export const sendEventDataLayer = (event) => {
  if (!isInitialized) return

  ReactGA.event(event.event, {
    ...event,
  })
}